<template>
  <div class="tel-panel" :class="{'tel-panel-mask':status==='endcall','tel-panel-z-index':status==='endcall' || status==='call'}">
    <!--    来电-->
    <div v-show="status === 'call'" class="tel-call_panel">
      <div class="tel-call_bg">
      <span class="tel-call_from">
        老师邀请你发言
      </span>
        <div class="tel-call_anim"></div>
        <button class="tel-call_answer" @click="onAnswerBtnClick">接听</button>
      </div>
      <audio src="/static/audio/call.mp3" ref="audio" loop autoplay></audio>
    </div>
    <!--连接中-->
    <div v-show="status === 'linking'" :class="telephoneClass" class="tel-answer_panel">
      <span class="tel-answer_state">努力连接中...</span>
      <div class="tel-answer_linking"></div>
    </div>

    <!-- 连接失败-->

    <!-- 通话中-->
    <div v-if="false" v-show="status === 'talking'" :class="telephoneClass" class="tel-answer_panel">
      <span class="tel-answer_state">发言中...</span>
      <div class="tel-answer_talking">
        <div class="tel-talking_anim l"></div>
        <div class="tel-talking_mic"></div>
        <div class="tel-talking_anim r"></div>
      </div>
    </div>
    <!-- 结束通话 -->
    <div v-show="status === 'endcall'" class="tel-call_panel tel-end_call_panel">
      <p>发言结束啦，下次也要积极发言哦</p>
    </div>
    <!--    人员列表-->
    <div v-if="false">
      <div id="teacher" style="width: 200px;height: 200px;border-radius:100px;overflow:hidden;background: #000;"></div>
      <div id="student" style="width: 200px;height: 200px;border-radius:100px;overflow:hidden;background: #000"></div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web-limi";

export default {
  name: "tellphoneAnswer",
  props: {
    status: String,
    info: Object, //连麦人信息
    telephoneClass: String
  },
  mounted() {
    this.initAnim();
  },
  watch:{
    status(val){
      console.log(val)
      if(val==="call"){
        this.$refs.audio.play();
      }else{
        this.$refs.audio.pause()
      }

    }
  },
  methods: {
    initAnim() {
      lottie.loadAnimation({
        container: document.querySelector(".tel-call_anim"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "static/lottie/phone.json"
      });
      lottie.loadAnimation({
        container: document.querySelector(".tel-answer_linking"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "static/lottie/linking.json"
      });
      lottie.loadAnimation({
        container: document.querySelector(".tel-talking_anim.l"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "static/lottie/talking.json"
      });
      lottie.loadAnimation({
        container: document.querySelector(".tel-talking_anim.r"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: "static/lottie/talking.json"
      });
    },
    onAnswerBtnClick() {
      this.$emit("answerTel");
    }
  }
};
</script>

<style scoped lang="less" rel="stylesheet/less">
.tel-panel {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 96;
  pointer-events: none;
}
.tel-panel-z-index {
  z-index: 999999990;
}
.tel-panel-mask {
  background: rgba(0, 0, 0, 0.6);
  pointer-events: auto;
}
.tel-call_panel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: auto;
}

.tel-call_bg {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  width: 368px;
  height: 312px;
  background: #f5ffff;
  border-radius: 15px;
  box-shadow: 0px 12px 23px 0px rgba(0, 127, 167, 0.12);
  font-family: PingFangSC, PingFangSC-Medium;
}

.tel-call_from {
  margin-top: 29px;
  font-size: 26px;
  font-weight: 500;
  color: #333333;
  line-height: 37px;
}

.tel-call_anim {
  margin-top: 20px;
  width: 105px;
  height: 105px;
  border-radius: 52px;
  /*background: #D3F9FE;*/
}

.tel-call_answer {
  margin-top: 26px;
  width: 248px;
  height: 59px;
  background: #27ce61;
  border-radius: 30px;
  box-shadow: 0px 8px 17px 0px rgba(0, 192, 67, 0.25);
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  line-height: 30px;
  cursor: pointer;
}
.tel-answer_panel {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 308px;
  height: 192px;
  background: #ffffff;
  border-radius: 15px 15px 0px 0px;
  font-family: PingFangSC, PingFangSC-Regular;
  pointer-events: auto;
}
.tel-answer_panel-level1 {
  width: 438px;
  height: 252px;
  .tel-answer_state{
    margin: 46px 0 26px 0;
    font-size: 26px;
  }
  .tel-answer_linking,
  .tel-talking_mic {
    width: 88px;
    height: 88px;
    border-radius: 44px;
    /*background: #D3F9FE;*/
  }
  .tel-talking_anim{
    display: inline-block;
    width: 60px;
    height: 40px;
  }
}
.tel-answer_panel-level2 {
  width: 378px;
  height: 222px;
  .tel-answer_state{
    margin: 36px 0 16px 0;
    font-size: 26px;
  }
  .tel-answer_linking,
  .tel-talking_mic {
    width: 78px;
    height: 78px;
    border-radius: 39px;
    /*background: #D3F9FE;*/
  }
  .tel-talking_anim{
    display: inline-block;
    width: 50px;
    height: 40px;
  }
}
.tel-answer_state {
  margin: 26px 0 10px 0;
  font-size: 19px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  line-height: 27px;
}

.tel-talking_anim,
.tel-talking_mic {
  display: inline-block;
  width: 40px;
  height: 30px;
}

.tel-answer_linking,
.tel-talking_mic {
  width: 68px;
  height: 68px;
  border-radius: 34px;
  /*background: #D3F9FE;*/
}

.tel-talking_mic {
  margin: 0 10px;
  background: url(../../../static/img/video/mic.png) no-repeat;
  background-size: contain;
}

.tel-answer_talking {
  display: flex;
  align-items: center;
  height: 68px;
  margin-top: 8px;
}
.tel-end_call_panel {
  width: 480px;
  height: 335px;
  background-color: #ffffff;
  border-radius: 15px;
  background-image: url(../../assets/img/video/end_call.png);
  background-repeat: no-repeat;
  background-position: 75px 36px;
  background-size: 267px 192px;
  pointer-events: auto;
}
.tel-end_call_panel p {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: #333333;
  padding-top: 268px;
}
</style>



// WEBPACK FOOTER //
// src/components/basic/telephonePanel.vue